






























import {Component, Prop} from "vue-property-decorator";
import Vue from 'vue';
import $ from 'jquery';


@Component
export default class Modal extends Vue {
    @Prop() big: boolean;
    
    mounted() {
        $("body").addClass("modal-open");
    }
    
    destroyed() {
        $("body").removeClass("modal-open");
    }
}
